module.exports = __webpack_public_path__ + "media/sos.6065b74b.mp3";